export default {
    list: {
        title: 'Ticket sets',
        empty: 'No ticket sets',
        cols: {
            name: 'Name',
            event: 'Event',
            entries: 'Entries',
            entryPause: 'Min between',
            validate: 'Notice',
            tickets: 'Tickets'
        },
        viewTickets: 'View tickets'
    },
    filter: {
        search: 'Search',
        event: 'Event'
    },
    form: {
        name: 'Name',
        customName: 'Notice on check',
        validate: 'Activate notice on check',
        section: {
            edit: 'Edit',
            metadata: 'Metadata',
            prices: 'Price tiers'
        }
    },
    metadata: {
        event: 'Event',
        prefix: 'Prefix',
        entries: 'Entries',
        entryPause: 'Min between entries',
        unlimited: 'Unlimited',
        bzucoId: 'Bzuco ID',
        yes: 'Yes',
        no: 'No'
    },
    prices: {
        cols: {
            name: 'Name',
            title: 'Ticket text',
            people: 'People',
            price: 'Price',
            currency: 'Currency'
        },
        empty: 'No price tiers'
    },
    bzucoSynced: {
        badge: 'Synced',
        tooltip: 'Synced from external system'
    },
    confirm: {
        unsavedChanges: 'You have unsaved changes. Close anyway?'
    },
    toast: {
        saved: 'Ticket set saved'
    },
    qr: {
        title: 'Configuration QR code',
        addToClipboard: 'Add to clipboard',
        added: 'Added to clipboard'
    }
}
